import { Toaster as SonnerToaster, toast as sonnerToast } from "sonner";

// ─────────────────────────────────────────────
// Toast (via Sonner)
//
// Success, error, warning, info variants.
// Auto-dismiss 5s. Position: top-right (design-system.md §9.13, 24px from edges).
// Design: §9.13 Error State Patterns — Toast Notification
// ─────────────────────────────────────────────

/**
 * Drop the <Toaster /> component into your app root (AppLayout / main.tsx).
 */
export function Toaster() {
  return (
    <SonnerToaster
      position="top-right"
      offset={24}
      toastOptions={{
        duration: 5000,
        style: {
          background: "var(--bg-card)",
          border: "1px solid var(--border-default)",
          borderRadius: "8px",
          color: "var(--text-primary)",
          fontFamily: "'DM Sans', sans-serif",
          fontSize: "14px",
          padding: "12px 16px",
          boxShadow: "0 8px 32px rgba(0,0,0,0.4)",
        },
        classNames: {
          toast: "flex items-start gap-3",
          title: "text-[14px] font-medium text-text-primary",
          description: "text-[14px] text-text-secondary mt-0.5",
        },
      }}
    />
  );
}

/**
 * Typed toast helpers that map to KIBORG color tokens.
 * Usage: toast.success("Saved", "Assessment saved successfully")
 */
export const toast = {
  success: (title: string, description?: string): void => {
    sonnerToast.success(title, {
      description,
      style: { borderLeft: "3px solid var(--success)" },
    });
  },

  error: (title: string, description?: string): void => {
    sonnerToast.error(title, {
      description,
      style: { borderLeft: "3px solid var(--danger)" },
    });
  },

  warning: (title: string, description?: string): void => {
    sonnerToast.warning(title, {
      description,
      style: { borderLeft: "3px solid var(--warning)" },
    });
  },

  info: (title: string, description?: string): void => {
    sonnerToast.info(title, {
      description,
      style: { borderLeft: "3px solid var(--info)" },
    });
  },

  dismiss: (id?: string | number): void => {
    sonnerToast.dismiss(id);
  },
};
